import { isNull, omit, pickBy } from 'lodash';

export const isShallowEqual = <T extends { [key: string]: unknown }>(
  objA: T,
  objB: T,
) => {
  if (objA === objB) {
    return true;
  }
  const objAKeys = Object.keys(objA);
  const objBKeys = Object.keys(objB);
  if (objAKeys.length !== objBKeys.length) {
    return false;
  }
  return objAKeys.every(key => key in objB && objA[key] === objB[key]);
};

export const cleanNulls = <T extends object>(input: T | null | undefined) =>
  omit(
    pickBy(input, v => !isNull(v)),
    '__typename',
  );

const UNSAFE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

export const deepOmit = <T extends object>(value: T, key: string): T => {
  const _omit = (currentValue: unknown): unknown => {
    if (Array.isArray(currentValue)) {
      return currentValue.map(i => _omit(i));
    } else if (typeof currentValue === 'object' && currentValue !== null) {
      return Object.keys(currentValue).reduce<Record<string, unknown>>(
        (newObject, k) => {
          if (k === key || UNSAFE_KEYS.has(k)) return newObject;
          newObject[k] = _omit((currentValue as Record<string, unknown>)[k]);
          return newObject;
        },
        {},
      );
    }
    return currentValue;
  };
  return _omit(value) as T;
};
